import { render, staticRenderFns } from "./AddNewReseller.vue?vue&type=template&id=9fb29bca&scoped=true"
import script from "./AddNewReseller.vue?vue&type=script&lang=js"
export * from "./AddNewReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb29bca",
  null
  
)

export default component.exports